export default "__VITE_ASSET__UknSIsxc__"